import * as React from "react";
import { Text, View } from "react-native";
import { Stack, useRouter } from "expo-router";
import { Controller } from "react-hook-form";

import { ResponsiveRenderer } from "~/components/ResponsiveRenderer";
import { useSaveFormContext } from "~/components/SaveForm/shared";
import { isWebDesktop } from "~/lib/constants";
import { useAccountStore } from "~/stores/space";
import { Button } from "~/ui/Button";
import { TextInput } from "~/ui/TextInput";

export default function SaveFormEditLink() {
  const { store: account } = useAccountStore();
  const { push } = useRouter();
  const { control, formState, handleSubmit, setValue } = useSaveFormContext();

  return (
    <View className="gap-y-4 px-4">
      <ResponsiveRenderer
        webDesktop={null}
        default={
          <Stack.Screen
            options={{
              headerTitle: "Edit link",
            }}
          />
        }
      />
      <View />
      <Controller
        control={control}
        name="url"
        render={({ field, fieldState }) => (
          <View className="gap-y-1">
            <TextInput
              onChangeText={field.onChange}
              value={field.value ?? ""}
              autoFocus
              placeholder="Paste a link here"
              errorMessage={fieldState.error?.message}
            />
            {(() => {
              try {
                const url = new URL(field.value);
                return (
                  <View className="flex-row">
                    <Text className="text-white">Link for </Text>
                    <Text className="text-text-brand">
                      {url.hostname.replace("www.", "")}
                    </Text>
                  </View>
                );
              } catch (e) {}
            })()}
          </View>
        )}
      />
      <View />

      <Button
        isLoading={formState.isSubmitting}
        onPress={handleSubmit(() => {
          if (isWebDesktop()) {
            return setValue("step", "form");
          }
          push(`/${account.slug}/link/form/`);
        })}
      >
        Use this URL
      </Button>
    </View>
  );
}
